<template>
    <div class="search-card search-card__professional">
         <a :href="url">
        <div class="search-card__image" :style="`background-image: url(${profileImage});`"></div>
        </a>
        <div class="search-card__body">
            <div class="search-card__details">
                <a :href="url" v-if="professionalName" class="search-card__name">{{ professionalName }}</a>
                <div v-if="title" class="search-card__title">{{ title }}</div>
            </div>
            <div class="search-card__actions">
                <div class="search-card__phone">   
                    <div class="search-card__phone-link" v-if="directPhone !== null"><span>D: </span><a title="Direct Phone" :href="`tel:` + directPhone">{{ directPhone }}</a></div>
                </div>
                <!-- <div class="search-card__icons">
                    <a v-if="linkedInUrl" class="search-card__icon" target="_blank" title="LinkedIn" :href="linkedInUrl">
                        <i class="icon-linkedin"></i>
                    </a>
                    <a v-if="officeEmail" class="search-card__icon" title="Office Email" :href="`mailto:` + officeEmail">
                        <i class="icon-envelope"></i>
                    </a>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["professionalName", "pageTitle", "title", "profileImage", "directPhone", "linkedInUrl", "officeEmail", "url"],
    data() {
        return {

        }
    }
}
</script>

